var map = {
	"./ABC.png": "07d8",
	"./ARCU.png": "74ce",
	"./ASCB.png": "fe34",
	"./AYCB.png": "4258",
	"./BANKWF.png": "c27b",
	"./BGB.png": "12a9",
	"./BHB.png": "45bd",
	"./BJBANK.png": "f1e5",
	"./BJRCB.png": "79c5",
	"./BOC.png": "a9eb",
	"./BOCD.png": "780ff",
	"./BOCY.png": "7c12",
	"./BOD.png": "2e45",
	"./BODD.png": "5b22",
	"./BOHAIB.png": "641f",
	"./BOJZ.png": "b76c",
	"./BOP.png": "6e9b",
	"./BOQH.png": "8804",
	"./BOSZ.png": "a4b9",
	"./BOYK.png": "08b5",
	"./BOZK.png": "2ece",
	"./BSB.png": "5b2b",
	"./BZMD.png": "1e9c",
	"./CBBQS.png": "eba2",
	"./CBKF.png": "18db",
	"./CCB.png": "6abf",
	"./CCQTGB.png": "653f",
	"./CDB.png": "e67b",
	"./CDCB.png": "8c9e",
	"./CDRCB.png": "2b6d",
	"./CEB.png": "9396",
	"./CGNB.png": "d2db",
	"./CIB.png": "b57f",
	"./CITIC.png": "8c7d",
	"./CMB.png": "03d0",
	"./CMBC.png": "caf7",
	"./COMM.png": "fae9",
	"./CQBANK.png": "0a48",
	"./CRCBANK.png": "e106",
	"./CSCB.png": "8b49",
	"./CSRCB.png": "9146",
	"./CZBANK.png": "e532",
	"./CZCB.png": "a02c",
	"./CZRCB.png": "787d",
	"./DAQINGB.png": "9b6d",
	"./DLB.png": "266a",
	"./DRCBCL.png": "1b22",
	"./DYCB.png": "f8f2",
	"./DYCCB.png": "2504",
	"./DZBANK.png": "8983",
	"./EGBANK.png": "e969",
	"./FDB.png": "d7f3",
	"./FJHXBC.png": "aa8b",
	"./FSCB.png": "f9c4",
	"./FXCB.png": "b479",
	"./GCB.png": "c4f6",
	"./GDB.png": "8240",
	"./GDRCC.png": "810e",
	"./GLBANK(1).png": "e211",
	"./GLBANK.png": "fe78",
	"./GRCB.png": "00dd",
	"./GSRCU.png": "3006",
	"./GXRCU.png": "3ca0",
	"./GYCB.png": "d26e",
	"./GZB.png": "46fc",
	"./GZRCU.png": "3637",
	"./H3CB.png": "26e0",
	"./HBC.png": "73b2",
	"./HBHSBANK.png": "5f21",
	"./HBRCU.png": "975c",
	"./HBYCBANK.png": "7801",
	"./HDBANK.png": "51bb",
	"./HKB.png": "6644",
	"./HNRCC.png": "59e2",
	"./HNRCU.png": "847a",
	"./HRXJB.png": "3833",
	"./HSBANK.png": "b8ed",
	"./HSBK.png": "a643",
	"./HURCB.png": "10aa",
	"./HXBANK.png": "2c52",
	"./HZCB.png": "cd7f",
	"./HZCCB.png": "2207",
	"./ICBC.png": "fdbf8",
	"./JHBANK.png": "8691",
	"./JINCHB.png": "bb3c",
	"./JLBANK.png": "5c22",
	"./JLRCU.png": "f54e",
	"./JNBANK.png": "d8d3",
	"./JRCB.png": "6a1e",
	"./JSB.png": "7dcf",
	"./JSBANK.png": "9591",
	"./JSRCU.png": "196e",
	"./JXBANK.png": "3996",
	"./JXRCU.png": "d2d2",
	"./JZBANK.png": "80b6",
	"./KLB.png": "92dd",
	"./KORLABANK.png": "9129",
	"./KSRB.png": "4a72",
	"./LANGFB.png": "6a9d",
	"./LSBANK.png": "2ed5e",
	"./LSBC.png": "b5d8",
	"./LSCCB.png": "83f3",
	"./LYBANK.png": "b2e5",
	"./LYCB.png": "c6c2",
	"./LZYH.png": "feb7",
	"./MTBANK.png": "ea17",
	"./NBBANK.png": "9c54",
	"./NBYZ.png": "fed1",
	"./NCB.png": "cc1b",
	"./NHB.png": "8440",
	"./NHQS.png": "7af2",
	"./NJCB.png": "47ca",
	"./NXBANK.png": "64d0",
	"./NXRCU.png": "d057",
	"./NYNB.png": "ec35",
	"./ORBANK.png": "ef9c",
	"./PSBC.png": "8f67",
	"./QDCCB.png": "5113",
	"./QLBANK.png": "221d",
	"./SCCB.png": "0fd7",
	"./SCRCU.png": "bd39",
	"./SDEB.png": "7c81",
	"./SDRCU.png": "979b",
	"./SHBANK.png": "04c5",
	"./SHRCB.png": "c213",
	"./SJBANK.png": "cf8d",
	"./SPABANK.png": "c051",
	"./SPDB.png": "44fa",
	"./SRBANK.png": "6c41",
	"./SRCB.png": "1024",
	"./SXCB.png": "3d32",
	"./SXRCCU.png": "c909",
	"./SZSBK.png": "c504",
	"./TACCB.png": "5707",
	"./TCCB.png": "f4ad",
	"./TCRCB.png": "0209",
	"./TRCB.png": "16bd",
	"./TZCB.png": "25a0",
	"./URMQCCB.png": "654d",
	"./WHCCB.png": "0a58",
	"./WHRCB.png": "ee47",
	"./WJRCB.png": "35e1",
	"./WRCB.png": "d771",
	"./WZCB.png": "dfad",
	"./XABANK.png": "fe5f",
	"./XCYH.png": "103f",
	"./XLBANK.png": "9eaf",
	"./XTB.png": "e240",
	"./XXBANK.png": "cbfc",
	"./XYBANK.png": "b388",
	"./YBCCB.png": "a73c",
	"./YDRCB.png": "0fb2",
	"./YNRCC.png": "2c4f",
	"./YQCCB.png": "c486",
	"./YXCCB.png": "1dc4",
	"./ZBCB.png": "1a4d",
	"./ZGCCB.png": "54cd",
	"./ZJKCCB.png": "0303",
	"./ZJNX.png": "a94e",
	"./ZJTLCB.png": "e244",
	"./ZRCBANK.png": "ff72",
	"./ZYCBANK.png": "5353",
	"./ZZBANK.png": "7cdc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b59";